import React, { ReactNode, Suspense } from "react";
import { SxProps } from "@mui/material";
import AuturaTextField from "components/inputs/AuturaTextField";
import { DateField, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import FormFieldSkeleton from "components/skeletons/FormField";
import { Await } from "react-router";
import { PickerValue } from "@mui/x-date-pickers/internals";

export interface TraxeroDateFieldProps {
  label?: string;
  id?: string;
  date: Date | null;
  setDate?: (date: Date | null) => void;
  readonly?: boolean;
  required?: boolean;
  margin?: "dense" | "normal" | "none";
  variant?: "standard" | "outlined" | "filled";
  disabled?: boolean;
  disableFuture?: boolean;
  resolve?: Promise<any>;
  views?: Array<"year" | "month" | "day">;
  sx?: SxProps;
}

const TraxeroDateField = ({
  label,
  id,
  date,
  setDate,
  readonly = false,
  required = false,
  margin = "none",
  variant = "outlined",
  disabled = false,
  disableFuture = false,
  views = ["year", "month", "day"],
  sx,
  resolve,
}: TraxeroDateFieldProps): ReactNode => {
  const { t } = useTranslation();
  if (id) {
    label = t(id);
  }

  const handleDateChange = (value: PickerValue | null) => {
    if (setDate && value) {
      setDate(value.toDate() || null);
    }
  };
  return (
    <Suspense
      fallback={
        <FormFieldSkeleton
          id={id}
          variant={variant}
          margin={margin}
          required={required}
        />
      }
    >
      <Await resolve={resolve}>
        {readonly ? (
          <AuturaTextField
            value={date ? dayjs(date).format('MM/YY') : ''}
            readonly
            name="plate-exp"
          />
        ) : (
          <DatePicker
            disabled={disabled}
            label={required ? `${label}*` : label}
            disableFuture={disableFuture}
            value={date ? dayjs(date) : null}
            views={views}
            slotProps={{ textField: { variant, margin, fullWidth: true } }}
            onChange={handleDateChange}
          />
        )}
      </Await>
    </Suspense>
  );
};

export default TraxeroDateField;
